import React, { useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";
import { Card, CardBody } from "reactstrap";

import { Loading } from "../../util/Loading";
import { Actions, AuthState, State } from "../types";

type Props = Readonly<{
  actions: Actions;
  auth: State["auth"];
}>;

export const RouteLogin = ({ actions: { loginWithToken, logout }, auth }: Props) => {
  const { authString, jobId } = useParams();
  useEffect(() => {
    if (auth.state === AuthState.initial && authString) {
      try {
        const token = atob(authString).split(":")[0];
        loginWithToken(token);
      } catch (err) {
        logout();
      }
    }
  }, [authString, auth.state]);
  if (auth.state === AuthState.loggedIn && jobId) {
    return <Redirect to={`/job/${encodeURIComponent(jobId)}`} />;
  }
  if (auth.state === AuthState.notLoggedIn) {
    return (
      <div className="d-flex align-items-center h-100 justify-content-center w-100">
        <Card color="secondary">
          <CardBody className="p-4">
            <h1 className="display1 m-0 text-white">
              Authentication failed. Please close this window.
            </h1>
          </CardBody>
        </Card>
      </div>
    );
  }
  return <Loading text="Authenticating" />;
};
RouteLogin.displayName = "RouteLogin";
